import { render, staticRenderFns } from "./SalesByProductChart.vue?vue&type=template&id=169fba3f&scoped=true"
import script from "./SalesByProductChart.vue?vue&type=script&lang=js"
export * from "./SalesByProductChart.vue?vue&type=script&lang=js"
import style0 from "./SalesByProductChart.vue?vue&type=style&index=0&id=169fba3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169fba3f",
  null
  
)

export default component.exports